import { observer } from 'mobx-react-lite'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { TasksCard } from '@/features/jobs/details/components/TasksCard'

export interface TasksCardContainerProps {
  vm: JobDetailsViewModel
}

export const TasksCardContainer = observer(function TasksCardContainer({
  vm,
}: TasksCardContainerProps) {
  if (!vm.collaboratorsVm.currentUserCollaborator) {
    return null
  }

  return (
    <TasksCard
      canCloseAsCollaborator={!!vm.actionsVm.canCloseAsCollaborator}
      onCompleteJob={vm.requestCloseAsCollaborator}
      testId="current-task-new"
      titleTestId="current-task-title-new"
      completeButtonTestId="complete-job-new"
      emptyTestId="no-task-list"
    />
  )
})
